import { init as initConfig, setup as setupConfig } from '@cian/config/browser';
import { init as initLogger } from '@cian/logger/browser';
import { init as initTelemetry, setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi, setup as setupHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { UNIQUE_CONFIG_KEY } from '../../../shared/constants/config';
import { initStore } from '../../../shared/redux';
import { TelemetryService as initTelemetryService } from './services/telemetry.service';

export const setupDependencies = () => {
  setupConfig({ settingsKey: UNIQUE_CONFIG_KEY });
  setupTelemetry();
  setupHttpApi({});
};

export const initDependencies = () => {
  const config = initConfig();
  const logger = initLogger();
  initTelemetry();
  const httpApi = initHttpApi();
  initWeb();

  const telemetryService = initTelemetryService();

  initStore({ config, logger, httpApi, telemetryService });
};
